import React, { useEffect, useState } from "react";
import { ShippingRate } from "../../Interfaces/ShippingInfo";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import "./ShippingUI.css";
import { LoggedInAccount } from "../../Interfaces/AccountUsers";
import { getCurrentlyLoggedInUser } from "../../CommonFunctions";
interface BuyShippingLabelProps {
  selectedRateId: string | null;
  orderId: number;
  isLoading: boolean;
  shippingRates: ShippingRate[];
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedRateId: React.Dispatch<React.SetStateAction<string | null>>;
}


const BuyShippingLabel: React.FC<BuyShippingLabelProps> = ({
  selectedRateId,
  orderId,
  isLoading,
  shippingRates,
  setSelectedRateId,
  setIsLoading,
}) => {
  const updateShippingDetails = (rate: ShippingRate) => {
    console.log("Selected rate:", rate);
    setSelectedRateId(rate.object_id);
    setShippingCost(parseFloat(rate.amount));
    setShippingService(rate.servicelevel.name);
    setShippingEstimatedDays(rate.estimated_days);
  };

  const [shippingCost, setShippingCost] = useState<number>(0);
  const [shippingService, setShippingService] = useState<string>("");
  const [shippingEstimatedDays, setShippingEstimatedDays] = useState<number>(0);
  const [loggedInAccountId, setLoggedInAccountId] = useState<LoggedInAccount | null>(null);

  useEffect(() => {
    const fetchLoggedInAccount = async () => {
      try {
        const response = await getCurrentlyLoggedInUser();
        setLoggedInAccountId(response);
      } catch (error) {
        console.error("Error fetching logged in account:", error);
      }
    };
    fetchLoggedInAccount();
  }, [loggedInAccountId]);

  const confirmShippingRate = async () => {
    try {
      setIsLoading(true);
      if (!selectedRateId) {
        alert("Please select a shipping rate.");
        return;
      }
      const response = await fetchWithAuth(
        `${config.API_BASE_URL}orders/purchase-label/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ rate_id: selectedRateId }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        //open in new tab the link loacted in data.label_url
        const newWindow = window.open(data.label_url, "_blank");
        if (newWindow) {
          newWindow.focus();
        }

        const shippingRecordResponse = await fetchWithAuth(
          `${config.API_BASE_URL}orders/create-shipping-record/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_id: orderId,
              account_id: loggedInAccountId?.id || 1,
              tracking_number: data.tracking_number,
              shipping_carrier: shippingService,
              shipping_cost: shippingCost,
              estimated_days: shippingEstimatedDays,
            }),
          }
        );

      } else {
        alert("Failed to purchase shipping label.");
        console.error("Error purchasing shipping label:", data);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="shipping-ui-spinner-container">
          <div className="shipping-ui-spinner"></div>
          <p>Loading...</p>
        </div>
      ) : shippingRates.length === 0 ? (
        <p>
          No rates available. Enter dimensions and click "Get Shipping Rates".
        </p>
      ) : (
        <>
          <div className="shipping-ui-rate-list">
            {shippingRates.map((rate) => (
              <label
                className={`shipping-ui-rate-card ${
                  selectedRateId === rate.object_id
                    ? "shipping-ui-rate-card-selected"
                    : ""
                }`}
                key={rate.object_id}
              >
                <input
                  type="radio"
                  name="shippingRate"
                  value={rate.object_id}
                  checked={selectedRateId === rate.object_id}
                  onChange={() => updateShippingDetails(rate)}
                  className="shipping-ui-radio"
                />
                <div className="shipping-ui-rate-details">
                  <div className="shipping-ui-provider">
                    {rate.provider} - {rate.servicelevel.name}
                  </div>
                  <div>{rate.estimated_days} business day(s)</div>
                  <div>
                    {rate.currency} {rate.amount}
                  </div>
                </div>
                <img
                  src={rate.provider_image_75}
                  alt={`${rate.provider} logo`}
                  className="shipping-ui-logo"
                />
              </label>
            ))}
          </div>
          <button
            className="shipping-ui-button"
            onClick={confirmShippingRate}
            disabled={!selectedRateId || isLoading}
          >
            {isLoading ? "Processing..." : "Confirm Shipping Rate"}
          </button>
        </>
      )}
    </div>
  );
};
export default BuyShippingLabel;
